// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import Paginate from 'vuejs-paginate';
import VeeValidate from 'vee-validate';
import VueScrollTo from 'vue-scrollto';
import moment from 'moment';
import axios from 'axios';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import App from './App';
import store from './store';
import router from './router';
import en from './lang/en';
import th from './lang/th';
import VeeValidateConfig from './validator';
import AuthManager from './managers/AuthManager';
import StorageManager from './managers/StorageManager';

if (process.env.SENTRY && process.env.SENTRY.DSN) {
  Raven.config(process.env.SENTRY.DSN).addPlugin(RavenVue, Vue).install();
}

// for VeeValidate validate date_format
window.moment = moment;

Vue.use(VueI18n);
Vue.use(Paginate);
Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(VeeValidate, VeeValidateConfig);

const storageManager = new StorageManager();
storageManager.initStorage();

// config language
const i18n = new VueI18n({
  locale: 'th', // set locale
  messages: {
    th: th,
    en: en,
  }, // set locale messages
});

// config axios
axios.defaults.baseURL = process.env.BASE_URL;

// intercept response to check status code
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const parser = document.createElement('a');
  parser.href = error.config.url;

  if (parser.pathname === '/oauth/token') {
    // not check 401, 403 for /oauth/token api
    return Promise.reject(error);
  }

  // check unauthorize response
  if (error.response.status === 401 ||
      error.response.status === 403) {
    // handle receive 401 from /api/user/logout
    if (parser.pathname === '/api/user/logout') {
      return Promise.resolve();
    }

    const namespace = router.currentRoute.params.namespace;

    if (namespace) {
      // clear token
      const authManager = new AuthManager();
      authManager.logout(namespace).then(() => {
        // redirect to team login page
        router.push(`/${namespace}/login`);
        return;
      });
      return Promise.reject(error);
    } else {
      // redirect to login page
      router.push(`/login`);
      return Promise.reject(error);
    }
  } else {
    return Promise.reject(error);
  }
});

// centralized event hub pattern
const eventHub = new Vue();

// add event hub to Vue components by using Mixins
Vue.mixin({
  data: function() {
    return {
      eventHub: eventHub,
    };
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  i18n,
  store,
  router,
  storageManager,
});



// WEBPACK FOOTER //
// ./src/main.js